const money = (cents, format) => {
  const amount = (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  if (format && format.includes('{{')) return format.replace(/\{\{\s*amount\s*\}\}/, amount);
  return `$${amount}`;
};

/* Price shown ex-GST, with a live GST-inclusive total that follows variant + quantity. */
const initGst = (root) => {
  const rate = Number(root.dataset.gstRate || 10) / 100;
  const format = root.dataset.moneyFormat || '';
  const amountEl = root.querySelector('[data-berara-gst-amount]');
  const totalEl = root.querySelector('[data-berara-gst-total-value]');
  const qtyNote = root.querySelector('[data-berara-gst-qty]');
  const wasEl = root.querySelector('[data-berara-gst-was]');
  let compares = {};
  try { compares = JSON.parse(root.querySelector('[data-berara-gst-compare]')?.textContent || '{}'); } catch (e) { compares = {}; }
  let prices = {};
  try {
    prices = JSON.parse(root.querySelector('[data-berara-gst-prices]')?.textContent || '{}');
  } catch (e) {
    prices = {};
  }

  const form = root.closest('.shopify-section, main')?.querySelector('form[action*="/cart/add"]');

  const read = () => {
    const idInput = form?.querySelector('[name="id"]');
    const qtyInput = form?.querySelector('[name="quantity"]');
    const id = idInput?.value;
    const unit = prices[id];
    const qty = Math.max(1, parseInt(qtyInput?.value || '1', 10) || 1);
    return { unit, qty };
  };

  const render = () => {
    const { unit, qty } = read();
    if (unit == null) return;
    if (amountEl) amountEl.textContent = money(unit, format);
    if (wasEl) {
      const was = compares[form?.querySelector('[name="id"]')?.value];
      if (was > unit) { wasEl.textContent = money(was, format); wasEl.hidden = false; } else { wasEl.hidden = true; }
    }
    if (totalEl) totalEl.textContent = money(Math.round(unit * qty * (1 + rate)), format);    if (qtyNote) {
      if (qty > 1) {
        qtyNote.textContent = ` (${qty} panels)`;
        qtyNote.hidden = false;
      } else {
        qtyNote.hidden = true;
      }
    }
  };

  render();
  document.addEventListener('change', (e) => {
    if (e.target instanceof Element && e.target.closest('form[action*="/cart/add"]')) render();
  });
  document.addEventListener('input', (e) => {
    if (e.target instanceof Element && e.target.getAttribute('name') === 'quantity') render();
  });
  if (form) new MutationObserver(render).observe(form, { subtree: true, attributes: true, attributeFilter: ['value'], childList: true });
};

/* Panel calculator: wall width / panel width, rounded up, plus waste allowance. */
const initCalc = (root) => {
  const panelWidth = parseFloat(root.dataset.panelWidth || '0.6');
  const waste = parseFloat(root.dataset.waste || '10');
  const widthEl = root.querySelector('[data-berara-calc-width]');
  const heightEl = root.querySelector('[data-berara-calc-height]');
  const out = root.querySelector('[data-berara-calc-result]');
  if (!widthEl || !out || !panelWidth) return;

  const render = () => {
    const width = parseFloat(widthEl.value);
    if (!width || width <= 0) {
      out.hidden = true;
      out.textContent = '';
      return;
    }
    const base = Math.ceil(width / panelWidth);
    const extra = Math.ceil((base * waste) / 100);
    const total = base + extra;
    const height = parseFloat(heightEl?.value || '');
    out.hidden = false;
    out.innerHTML =
      `For a <strong>${width}m</strong> wide wall you need <strong>${total} panels</strong>` +
      ` — ${base} to cover the wall plus ${extra} extra (${waste}% allowance).` +
      (height ? ` Choose a panel length of at least <strong>${height}m</strong> for your wall height.` : '') +
      ` <button type="button" data-berara-calc-apply>Use ${total} as quantity</button>`;
  };

  widthEl.addEventListener('input', render);
  heightEl?.addEventListener('input', render);

  out.addEventListener('click', (e) => {
    const btn = e.target instanceof Element ? e.target.closest('[data-berara-calc-apply]') : null;
    if (!btn) return;
    const total = parseInt(out.textContent.match(/need (\d+) panels/)?.[1] || '0', 10);
    const qty = document.querySelector('form[action*="/cart/add"] [name="quantity"]');
    if (total && qty) {
      qty.value = String(total);
      qty.dispatchEvent(new Event('change', { bubbles: true }));
      qty.dispatchEvent(new Event('input', { bubbles: true }));
      qty.closest('.shopify-section, main')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
};

document.querySelectorAll('[data-berara-gst]').forEach(initGst);
document.querySelectorAll('[data-berara-calc]').forEach(initCalc);
